import { jsx as _jsx } from "react/jsx-runtime";
import { MoonIcon, SunIcon } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { memo } from "react";
import { useAssetModalTheme } from "~/components/AssetModalV2/AssetModalThemeContextProvider";
export const ThemeToggleButton = /*#__PURE__*/ memo(()=>{
    const { theme, setTheme } = useAssetModalTheme();
    return /*#__PURE__*/ _jsx(IconButton, {
        icon: theme === "dark" ? MoonIcon : SunIcon,
        label: "Toggle Content Left Panel",
        appearance: "ghost",
        color: "grey",
        onClick: ()=>setTheme((prev)=>prev === "dark" ? "light" : "dark")
    });
});
ThemeToggleButton.displayName = "ThemeToggleButton";
